export default {
  RIGHT: 'Right',
  RIGHT_NO_PADDING: 'Right - No Padding',
  FULL_WIDTH: 'Background - Full Width',
  BACKGROUND_FIXED_HEIGHT: 'Background - Fixed Height',
  BACKGROUND_VARIABLE_HEIGHT: 'Background - Flexible Height',
};
